// extracted by mini-css-extract-plugin
module.exports = {"tabs-wrapper":"Tabs_tabs-wrapper__PXLp2","tabs-container":"Tabs_tabs-container__Wgx31","no-background":"Tabs_no-background__ahs5u","content":"Tabs_content__k4w_i"};